import {
  Box,
  Link,
  Paper,
  Table,
  Stack,
  useTheme,
  Checkbox,
  TableRow,
  MenuItem,
  TableCell,
  TableHead,
  TableBody,
  Typography,
  ListItemIcon,
  TableContainer,
  ListItemText,
} from "@mui/material";
import Head from "next/head";
import { TbShirtSport } from "react-icons/tb";
import { useFormContext } from "react-hook-form";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

import constants from "@/global/config/constants";

import type { TeamConfig } from "@/global/hooks/useTeamConfig";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games ",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect to your{" "}
        <Link
          href={"https://am.ticketmaster.com/tbjrc/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Toronto Blue Jays
        </Link>{" "}
        account using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for the games.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Ticket will be available to be managed in your{" "}
        <Link
          target={"_blank"}
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://am.ticketmaster.com/tbjrc/?_gl=1*1m1gqlb*_gcl_au*MjQ5NzAxMzA0LjE3NzAwNDg4NDIuMjYxNjgwOTM0LjE3NzQzNzkwODcuMTc3NDM3OTA4Ng..*_ga*MTc1OTU3NDIyMC4xNzYxNzg5NDIx*_ga_N8YFCZLYSZ*czE3NzQzOTAzMTckbzUzJGcxJHQxNzc0MzkxMDY4JGo2MCRsMCRoMTU5NzczNTE0MQ.."
        >
          Toronto Blue Jays
        </Link>{" "}
        Account Manager within 24 hours. Reach out to Ticket Sales & Services at{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="tel:4163411234"
        >
          (416) 341-1234
        </Link>{" "}
        for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How do I purchase a 10-Game Flex Pack?",
    description: (
      <>
        • Choose 10 or more games that work for you.
        <br />
        • Determine your number of seats for each game.
        <br />
        • Select your favourite seat locations - this can change for each game!
        <br />• Once you select 10 games, you unlock access to purchase Opening
        Night presented by TD & Canada Day.
      </>
    ),
  },
  {
    title:
      "How do I secure Opening Night presented by TD and Canada Day access?",
    description:
      "If you purchase a 10-Game Flex Pack, you unlock access to purchase Opening Night presented by TD and Canada Day.",
  },
  {
    title: "Do I receive Postseason Access with my Flex Pack?",
    description:
      "10-Game Flex Pack purchasers receive guaranteed 2026 Postseason ticket access.",
  },
  {
    title: "Which games can you save 15% compared to single game tickets?",
    description: (
      <>
        Below is list of all discounted games. Subject to availability.
        <br />
        <br />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Game Date</TableCell>
                <TableCell>Opponent</TableCell>
                <TableCell>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Mon, Mar 30
                </TableCell>
                <TableCell>COL</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Tue, Mar 31
                </TableCell>
                <TableCell>COL</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Wed, Apr 1
                </TableCell>
                <TableCell>COL</TableCell>
                <TableCell>1:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Fri, Apr 10
                </TableCell>
                <TableCell>MIN</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Fri, Apr 24
                </TableCell>
                <TableCell>CLE</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Mon, Apr 27
                </TableCell>
                <TableCell>BOS</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Tue, Apr 28
                </TableCell>
                <TableCell>BOS</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Wed, Apr 29
                </TableCell>
                <TableCell>BOS</TableCell>
                <TableCell>3:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Mon, May 11
                </TableCell>
                <TableCell>TB</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Tue, May 12
                </TableCell>
                <TableCell>TB</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Wed, May 13
                </TableCell>
                <TableCell>TB</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Mon, May 25
                </TableCell>
                <TableCell>MIA</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Tue, May 26
                </TableCell>
                <TableCell>MIA</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Fri, Sep 11
                </TableCell>
                <TableCell>BAL</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Mon, Sep 14
                </TableCell>
                <TableCell>DET</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Tue, Sep 15
                </TableCell>
                <TableCell>DET</TableCell>
                <TableCell>7:07 PM</TableCell>
              </TableRow>

              <TableRow
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  Wed, Sep 16
                </TableCell>
                <TableCell>DET</TableCell>
                <TableCell>3:07 PM</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </>
    ),
  },
  {
    title: "How do unlimited exchanges work?",
    description: (
      <>
        After purchasing your Flex Pack, enjoy the flexibility of{" "}
        <b>unlimited ticket exchanges</b> up to 48 hours before game time on{" "}
        <i>Blue Jays</i>{" "}
        <Link
          href={"https://am.ticketmaster.com/tbjrc/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Account Manager
        </Link>
        . Game dates and seating locations are valued at different tiers but you
        can exchange your tickets for the same or lower priced ticket at no
        additional cost. If there is an increase in cost between your current
        tickets and new tickets, you are responsible for payment of the
        increased ticket cost. No refunds or credits will be provided in
        connection with exchanges. You may exchange up to eight (8) tickets from
        your Flex Packs to any one game. Your Flex Pack tickets will be
        available to be managed on your <i>Toronto Blue Jays</i> Account Manager
        on or before March 2, 2026.
      </>
    ),
  },
  {
    title: "Is there a maximum number of games you can add to your Flex Pack?",
    description: "Yes, you can add a maximum of 19 games.",
  },
];

export const RegistrationTerms = () => (
  <>
    In connection with your registration, you understand that your personal
    information will be submitted to (i) Rogers Blue Jays Baseball Partnership
    (owner of the Toronto Blue Jays baseball team) ("<b>RBJBP</b>") and treated
    in accordance with the{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://bluejays.com/privacy"
    >
      RBJBP Privacy Policy
    </Link>
    , and MLB Advanced Media, L.P. ("<b>MLB</b>") and will be treated in
    accordance with the{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://mlb.com/privacy"
    >
      MLB Privacy Policy
    </Link>
    . You consent to the collection, use, and disclosure of my personal
    information in accordance with the foregoing privacy policies. In addition,
    by completing a transaction for a Toronto Blue Jays ticket or ticket
    product, you consent to the applicable{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.bluejays.com/ticketterms"
    >
      Toronto Blue Jays Terms
    </Link>{" "}
    and Conditions, as amended from time to time and the{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href=" https://www.mlb.com/tou"
    >
      MLB Terms of Use
    </Link>
    .
  </>
);

export const CheckoutTerms = () => (
  <>
    I acknowledge that I have read, understand, and agree to the Toronto Blue
    Jays{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://mktg.mlbstatic.com/bluejays/downloads/pdfs/y2025/Blue_Jays_2026_Flex_Pack_Terms_and_Conditions.pdf"
    >
      10-Game Flex Pack Terms and Conditions
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href=" https://www.mlb.com/tou"
    >
      MLB Terms of Use
    </Link>
    .
  </>
);

export const AdditionalCheckoutInputFields = () => {
  const theme = useTheme();
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Stack direction={"row"} alignItems={"flex-start"}>
      <Box>
        <Checkbox
          {...register("secondaryTerms", {
            required: "You need to accept the terms and conditions",
          })}
          sx={{ marginLeft: "-8px", marginTop: "-8px" }}
        />
      </Box>
      <Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            I understand that my personal information will be submitted to (i)
            Rogers Blue Jays Baseball Partnership (owner of the Toronto Blue
            Jays baseball team) ("<b>RBJBP</b>") and treated in accordance with
            the{" "}
            <Link
              target="_blank"
              sx={{
                fontWeight: 500,
                color: "primary.main",
                textDecoration: "none",
              }}
              href="https://www.bluejays.com/privacy"
            >
              RBJBP Privacy Policy
            </Link>
            , and MLB Advanced Media, L.P. ("<b>MLB</b>") and will be treated in
            accordance with the{" "}
            <Link
              target={"_blank"}
              sx={{
                fontWeight: 500,
                color: "primary.main",
                textDecoration: "none",
              }}
              href="https://mlb.com/privacy"
            >
              MLB Privacy Policy
            </Link>
            . I consent to the collection, use, and disclosure of my personal
            information in accordance with the foregoing privacy policies.
            <br />
            <br />
            By completing a transaction, you will receive ticket-related
            commercial emails from the Toronto Blue Jays and bluejays.com, and
            you may receive customer service messages via email from the Toronto
            Blue Jays, bluejays.com, and MLB.com, including optional surveys
            regarding your Toronto Blue Jays experience and purchase. You may
            unsubscribe at any time.
            <br />
            <br />
            Your tickets will be available to be available to be managed by you
            prior to the date of the first game included in your ticket product.
            Please note that commercial resellers are not permitted to purchase
            Toronto Blue Jays tickets or ticket products and should not attempt
            to do so. Purchases made in contravention of the foregoing are
            subject to cancellation.
          </Typography>
        </Box>
        <Box>
          {errors?.secondaryTerms?.message ? (
            <Typography
              variant="caption"
              color={theme.palette.error.main}
              lineHeight={1.1}
            >
              {errors?.secondaryTerms?.message as string}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Stack>
  );
};

export const AnalyticsHeader = (props: { teamConfig: TeamConfig }) => {
  const { teamSchema } = props.teamConfig;

  return (
    <Head>
      <script
        nonce={process.env.pixelScriptNonce}
        id={`${teamSchema}-meta-pixel-script`}
        defer
        dangerouslySetInnerHTML={{
          __html: `
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '346053528923090');
              fbq('track', 'PageView');
              console.log('meta pixel page load event fired.');
              window.addEventListener("${constants.customEvents.eventPurchaseSuccess}", function(e) {
                try {
                  const { cartRes, checkoutRes } = e.detail;
                  fbq('track', 'Purchase', {
                    content_name: "${teamSchema}_event_purchase", 
                    value: String(cartRes.allInPrice), 
                    currency: 'USD', 
                    order_id: checkoutRes.orderNumber,
                  });
                  console.log('meta pixel purchase event fired.');
                } catch (error) {
                  console.log('Error in meta pixel purchase event', error); 
                }
              });
            `,
        }}
      />

      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          src="https://www.facebook.com/tr?id=346053528923090&ev=PageView&noscript=1"
        />
      </noscript>

      {/* Floodlight script */}
      <script
        nonce={process.env.googleTagManagerNonce}
        id={`${teamSchema}-floodlight-script`}
        defer
        dangerouslySetInnerHTML={{
          __html: `
            (function(){
              var FLOODLIGHT_SRC = '2946439';
              var FLOODLIGHT_TYPE_VIEW = 'torsa158';
              var FLOODLIGHT_CAT_VIEW = 'march000';
              var FLOODLIGHT_TYPE_PURCHASE = 'torsa158';
              var FLOODLIGHT_CAT_PURCHASE = 'march000';

              // Fire page view confirmation (image beacon)
              try {
                var ord = Math.floor(Math.random()*1e16);
                var img = new Image(1,1);
                img.style.display = 'none';
                img.alt = '${teamSchema} Floodlight View';
                img.src = 'https://ad.doubleclick.net/ddm/activity/src=' + FLOODLIGHT_SRC + ';type=' + FLOODLIGHT_TYPE_VIEW + ';cat=' + FLOODLIGHT_CAT_VIEW + ';ord=' + ord + '?';
                if (document.body) document.body.appendChild(img);
                console.log('Floodlight view ping fired.');
              } catch(e) { console.log('Floodlight view ping error', e); }

              // Purchase confirmation on app event
              window.addEventListener('${constants.customEvents.eventPurchaseSuccess}', function(e){
                try {
                  var cartRes = e && e.detail && e.detail.cartRes;
                  var checkoutRes = e && e.detail && e.detail.checkoutRes;
                  var ord = (checkoutRes && checkoutRes.orderNumber) || Math.floor(Math.random()*1e16);
                  var cost = cartRes && cartRes.allInPrice;
                  var qty = (cartRes && cartRes.totalSeats) || 1;
                  var url = 'https://ad.doubleclick.net/ddm/activity/src=' + FLOODLIGHT_SRC + ';type=' + FLOODLIGHT_TYPE_PURCHASE + ';cat=' + FLOODLIGHT_CAT_PURCHASE + ';ord=' + ord + ';qty=' + encodeURIComponent(String(qty)) + ';cost=' + encodeURIComponent(String(cost)) + '?';
                  var img = new Image(1,1);
                  img.style.display = 'none';
                  img.src = url;
                  img.alt = '${teamSchema} Floodlight Purchase';
                  if (document.body) document.body.appendChild(img);
                  console.log('Floodlight purchase ping fired.', { ord, cost, qty });
                } catch(err) {
                  console.log('Floodlight purchase ping error', err);
                }
              });
            })();
          `,
        }}
      />

      {/** tiktok script */}
      <script
        nonce={process.env.tiktokScriptNonce}
        defer
        id={`${teamSchema}-tik-tok-script`}
        dangerouslySetInnerHTML={{
          __html: `
              !(function (w, d, t) {
                w.TiktokAnalyticsObject = t;
                var ttq = (w[t] = w[t] || []);
                (ttq.methods = [
                  "page",
                  "track",
                  "identify",
                  "instances",
                  "debug",
                  "on",
                  "off",
                  "once",
                  "ready",
                  "alias",
                  "group",
                  "enableCookie",
                  "disableCookie",
                ]),
                  (ttq.setAndDefer = function (t, e) {
                    t[e] = function () {
                      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
                    };
                  });
                for (var i = 0; i < ttq.methods.length; i++)
                  ttq.setAndDefer(ttq, ttq.methods[i]);
                (ttq.instance = function (t) {
                  for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
                    ttq.setAndDefer(e, ttq.methods[n]);
                  return e;
                }),
                  (ttq.load = function (e, n) {
                    var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
                    (ttq._i = ttq._i || {}),
                      (ttq._i[e] = []),
                      (ttq._i[e]._u = i),
                      (ttq._t = ttq._t || {}),
                      (ttq._t[e] = +new Date()),
                      (ttq._o = ttq._o || {}),
                      (ttq._o[e] = n || {});
                    n = document.createElement("script");
                    (n.type = "text/javascript"),
                      (n.async = !0),
                      (n.src = i + "?sdkid=" + e + "&lib=" + t);
                    e = document.getElementsByTagName("script")[0];
                    e.parentNode.insertBefore(n, e);
                  });

                ttq.load("CR7M1F3C77U1F4DL6V9G");
                ttq.page();
                console.log("tiktok pixel page view fired.");
              })(window, document, "ttq");

              window.addEventListener(
                "${constants.customEvents.eventPurchaseSuccess}",
                async function (e) {
                  var cartRes = e && e.detail && e.detail.cartRes;
                  var checkoutRes = e && e.detail && e.detail.checkoutRes;

                  ttq.identify({
                    email: e.detail.user.email,
                    phone_number: "+1" + e.detail.user.phoneNumber,
                  });

                  ttq.track("CompletePayment", {
                    content_id: checkoutRes.orderNumber,
                    content_name: "${teamSchema}_event_purchase",
                    quantity: String(cartRes.totalSeats),
                    price: String(cartRes.allInPrice),
                    value: String(cartRes.allInPrice),
                    currency: "USD",
                  });
                  console.log("tik tok pixel purchase event fired.");
                }
              );
            `,
        }}
      />
    </Head>
  );
};

export const TCListItems = () => (
  <Box>
    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_blank",
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Privacy Policy</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_blank",
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Terms of Use</ListItemText>
    </MenuItem>
  </Box>
);
